import { RoleDTO, RolePrivilegeMap } from "common/dto";
import NavigationBlockerDialog from "common/elements/NavigationBlockerDialog";
import usePageTitle, { useForm } from "common/hooks";
import { useInfoDialog } from "common/InfoDialog";
import { convertToPrivilegeDtoList, diffUpdateSpec } from "common/utils";
import deepEqual from "deep-equal";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { IRootState, PASDispatch } from "reducers";
import roleFormValidations from "./role-validation";
import RolePrivilege from './RolePrivilege';

const EMPTY = {};

export default function RolePrivilegeUpdatePage() {
  const dispatch = useDispatch() as PASDispatch;
  const { langRolePrivilege } = useSelector((state: IRootState) => state.locale);
  const { roleId }: any = useParams();

  //currentRoleDetail-> role name, description, status
  const currentRoleDetail = useSelector((state: IRootState) => state.rolePrivilege.fetchedDetails[roleId!]) ?? EMPTY as RoleDTO;

  //currentRolePrivilegeMap -> privilege for this role
  const currentRolePrivilegeMap = currentRoleDetail.privilegeTable ?? EMPTY as RolePrivilegeMap;

  const initialRolePrivilege = useForm<RolePrivilegeMap>({});

  //for edit
  const roleForm = useForm<RoleDTO>({
    ...currentRoleDetail
  }, {
    validations: roleFormValidations(langRolePrivilege)
  });
  const rolePrivilegeForm = useForm<RolePrivilegeMap>({});

  const alertDialog = useInfoDialog();

  useEffect(() => {
    const roleFormValues = {
      ...currentRoleDetail
    }

    //for role detail
    roleForm.setValues({ ...roleFormValues })

    //for privilege
    rolePrivilegeForm.setValues(currentRolePrivilegeMap);
    initialRolePrivilege.setValues(currentRolePrivilegeMap);

    setInitialFormValues([roleFormValues, currentRolePrivilegeMap]);
  }, [currentRoleDetail])

  usePageTitle(langRolePrivilege.titleRoleDetail);

  useEffect(() => {
    dispatch({ type: 'RolePrivilege.FetchRequested', payload: { roleId: roleId ?? '' } });
  }, []);

  const [initialFormValues, setInitialFormValues] = useState<any>({});
  const unsaved = !deepEqual([roleForm.values, rolePrivilegeForm.values], initialFormValues, { strict: true });

  const onSave = () => {
    if (!roleForm.validate()) {
      return;
    }
    const currentList = convertToPrivilegeDtoList(roleId, initialRolePrivilege);
    const updatedList = convertToPrivilegeDtoList(roleId, rolePrivilegeForm);

    const result = diffUpdateSpec(currentList, updatedList, (a, b) => { return a.id === b.id });

    dispatch({
      type: 'RolePrivilege.UpdateRequested', payload: {
        ...roleForm.values,
        listUpdate: result
      } as RoleDTO
    });
  }


  return (
    <div>
      <NavigationBlockerDialog matchesUrl={`/roles/${roleId}`} unsaved={unsaved} goBack />
      {alertDialog.render()}
      <RolePrivilege roleForm={roleForm} rolePrivilegeForm={rolePrivilegeForm} onSave={onSave} unsaved={unsaved} />
    </div>
  );
}